// extracted by mini-css-extract-plugin
module.exports = {"modal":"ConfirmAudioModal_modal__D0Kf0","modalBody":"ConfirmAudioModal_modalBody__p6WVQ","acceptButton":"ConfirmAudioModal_acceptButton__3yAB1"};